export default () =>
  import(/* webpackChunkName: 'coffee/app/download/store' */ './Store');
